// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import NormalGameManager from "../../../manager/NormalGameManager";
import UserDataManage from "../../../model/UserDataManage";
import MilitaryCityItem from "./MilitaryCityItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MilitaryMapPopLayer extends BasePopUpLayer {

    // @property({type:cc.Node})
    // redPointNode : cc.Node = null;
	@property({ type: cc.Node, displayName:'' })
	cityLayout: cc.Node = null;

    // @property({type:cc.Prefab,displayName:"用户账本预制体"})
    // userAccountPrefab : cc.Prefab = null;
    
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
        let csvInfo = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.CITY);
        if (!csvInfo) {
            console.error(`CITY 数据未找到`);
            return;
        }
        let children = this.cityLayout.children;
        // let title = csvInfo.title;
        let idx = 0;
        for (let i in csvInfo) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            
            let nodeItem = children[idx];
            if (!nodeItem) {
                console.log('未找到节点 idx',idx);
                break;
            }

            // let info = csvInfo[i];
            let cityItem = nodeItem.getComponent(MilitaryCityItem);
            cityItem.setData(
                i
            );

            idx++;
        }

        this.disposeEarning();
    }

    disposeEarning() {
        let militaryCityDataManage = UserDataManage.instance.militaryCityDataManage;
        let militaryCityData = militaryCityDataManage.militaryCityData;
        if (militaryCityData.earningGoods.length <= 0) {
            return;
        }

        for (let i = 0; i < militaryCityData.earningGoods.length; i++) {
            let goodsId = Number(militaryCityData.earningGoods[i]);
            let count = militaryCityData.earningGoodsCount[i];
            NormalGameManager._instance.onPushGoods(goodsId, count);
        }
        
        let goods = [].concat(militaryCityData.earningGoods);
        let counts = [].concat(militaryCityData.earningGoodsCount);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MilitaryEarningLayer
            , null
            , {
                goods: goods
                , counts: counts
            }
        );

        militaryCityData.earningGoods = [];
        militaryCityData.earningGoodsCount = [];
        militaryCityData.saveLocalData();
    }

    onClickMyOfficer() {
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MilitaryMyOfficerLayer
        );
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
        this._carryData.parent.destroyNode();
    }

    // openBackpack() {
    //     O1HD.getManagers().soundMgr.playSound("anNiu").then();
    //     O1HD.emit("normalMode.notifyOpenBackpack");
    // }
    
    // openWeChatLayer() {
    //     O1HD.getManagers().soundMgr.playSound("anNiu").then();
    //     O1HD.emit("normalMode.refreshopenWeChat");
    // }

    // /**
    //  * 打开账单
    //  */
    // onBtnBill(){
    //     O1HD.getManagers().soundMgr.playSound("anNiu").then();
    //     let userAccountPrefab = cc.instantiate( this.userAccountPrefab );
    //     O1HD.Canvas().addChild( userAccountPrefab );
    //     userAccountPrefab.getComponent( UserAccountPrefab ).bindData( this._carryData.normalMode );
    // }

    // update(dt: number): void {
    //     if ( NormalGameManager._instance.getGameData().userAccountInfoNewMsg &&
    //         NormalGameManager._instance.getGameData().userAccountInfoNewMsg > 0 ){
    //             if (this.redPointNode && !this.redPointNode.active) {
    //                 this.redPointNode.active = true;
    //                 cc.Tween.stopAllByTarget(this.redPointNode.parent);
    //                 cc.tween(this.redPointNode.parent)
    //                     .to(0.5, {scale: 1.1})
    //                     .to(0.5, {scale: 0.9})
    //                     // .to(0.5, {scale: 1.1}, {easing: 'circIn'})
    //                     // .to(0.5, {scale: 0.9}, {easing: 'circOut'})
    //                     .union()
    //                     .repeatForever()
    //                     .start();
    //             }
    //     }else{
    //         if (this.redPointNode && this.redPointNode.active) {
    //             cc.Tween.stopAllByTarget(this.redPointNode.parent);
    //             this.redPointNode.active = false;
    //         }
    //     }
    // }

    // update (dt) {}
}
